<script lang="js" setup>
import miscMaskDark from '@images/pages/misc-mask-dark.png'
import miscMaskLight from '@images/pages/misc-mask-light.png'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'

/**
 * The shared shell for the app's full-page STATUS screens — the 404 / 500
 * error boundary (`error.vue`) and the 403 access-denied page
 * (`pages/account/unauthorized.vue`). One place for the centered wrapper, the
 * ErrorHeader, the illustration and the footer mask, so the two screens can't
 * drift apart.
 *
 * Actions go in the `#actions` slot and follow the UI guideline (§3): the quiet
 * SECONDARY button (`variant="tonal"`, with an icon) on the LEFT, the PRIMARY
 * action (`color="primary"`, the home icon, "Back to Home") on the RIGHT.
 */
defineProps({
  statusCode: { type: [String, Number], default: null },
  title: { type: String, default: '' },
  description: { type: String, default: '' },

  // The illustration src (imported by the caller: 404 vs 401 art).
  image: { type: String, required: true },
})

const themeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)
</script>

<template>
  <div class="misc-wrapper">
    <ErrorHeader
      :status-code="statusCode"
      :title="title"
      :description="description"
    />

    <!-- Secondary LEFT, primary RIGHT — the caller fills the slot in that order. -->
    <div class="d-flex flex-wrap justify-center gap-3 mb-11">
      <slot name="actions" />
    </div>

    <div class="misc-avatar w-100 text-center">
      <VImg
        :src="image"
        :max-height="$vuetify.display.smAndDown ? 350 : 500"
        :alt="title"
        class="mx-auto"
      />
    </div>

    <img
      class="misc-footer-img d-none d-md-block"
      :src="themeMask"
      alt=""
      height="320"
    >
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
